import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
// import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: {path: '/about/habit'}
  
    // component: HomeView,
    // children: [
    //   {
    //     path: '/home/:link',
    //     name: 'display',
    //     component: () => import('@/components/two_column_layout/PicBottom.vue')
    //   }
    // ]
  },
  {
    path: '/about/:link',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/document/:type/:file',
    name: 'document',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/DocumentPage.vue')
  },
  {
    path: '/404',
    name: '404',
    component: () => import('../views/ErrorPage.vue')
  }
  // ,{
  //   path: '/*',
  //   name: 'not-found',
  //   redirect: '/404 '
  // }
  ,{
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    // redirect: '/404',
    component: () => import('../views/ErrorPage.vue') // 使用redirect报错，
  }
]

const router = createRouter({
  // history: createWebHashHistory(),
  history: createWebHistory(),
  routes
})
// const whiteRouter = ['offical', 'game']
// router.beforeEach((to, from, next) => {
//   console.log('xh--', to.fullPath.replace('/about/', ''))
//   let path = to.fullPath
//   if (whiteRouter.includes(path.replace('/about/', ''))){
    
//     console.log('xh--router', true, whiteRouter.indexOf(path.replace('/about/', '')))
//     next()
//     // return
//   }
//   next()
// })

export default router
